import { render, staticRenderFns } from "./modularChild11.vue?vue&type=template&id=28561934&scoped=true"
import script from "./modularChild11.vue?vue&type=script&lang=js"
export * from "./modularChild11.vue?vue&type=script&lang=js"
import style0 from "./modularChild11.vue?vue&type=style&index=0&id=28561934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28561934",
  null
  
)

export default component.exports